"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntersectionService = void 0;
var inversify_1 = require("inversify");
var notifyEvents_1 = require("../constants/notifyEvents");
var types_1 = require("../types");
var IntersectionService = /** @class */ (function () {
    function IntersectionService() {
        var _this = this;
        this.io = null;
        this.items = [];
        this.exposingEntries = [];
        this.intersectionCallBack = function (entries) {
            entries.forEach(function (entry) {
                if (entry.intersectionRatio >= 0.5) {
                    _this.handleEntryIntersecting(entry);
                }
                else {
                    _this.handleEntryNotIntersecting(entry);
                }
            });
            _this.observableService.notify(notifyEvents_1.NOTIFY_ENTRY_INTERSECT_CALLBACK_END, entries);
        };
    }
    IntersectionService.prototype.handleEntryIntersecting = function (entry) {
        var exposingItem = {
            startTimestamp: Date.now(),
            entry: entry,
        };
        this.exposingEntries.push(exposingItem);
        this.observableService.notify(notifyEvents_1.NOTIFY_ENTRY_INTERSECTING, exposingItem);
    };
    IntersectionService.prototype.handleEntryNotIntersecting = function (entry) {
        var intersectedIndex = this.exposingEntries.findIndex(function (exposing) { return exposing.entry.target === entry.target; });
        if (intersectedIndex > -1) {
            // 曝光结束
            this.observableService.notify(notifyEvents_1.NOTIFY_ENTRY_INTERSECTED, this.exposingEntries[intersectedIndex]);
            this.exposingEntries.splice(intersectedIndex, 1);
        }
    };
    IntersectionService.prototype.createObserver = function (config) {
        this.config = config;
        this.io = new IntersectionObserver(this.intersectionCallBack, (config === null || config === void 0 ? void 0 : config.intersectionOptions) || {
            rootMargin: "0% 0%",
            threshold: [0.5],
        });
    };
    IntersectionService.prototype.init = function (config, force) {
        if (!this.io) {
            this.createObserver(config);
        }
        else if (force) {
            this.createObserver(config);
        }
        else if (!this.isIntersectionOptionsEqual(config, this.config)) {
            // 需要取消观察先 后续会创建一个新的 IntersectionObserver 示例
            this.stopObserve();
            this.stop();
            this.createObserver(config);
        }
    };
    /**
     * 判断前后的  intersectionOptions 是否有改变
     * 这里偷懒了，目前外部只会更改 rootMargin ，所以这里只对比 rootMargin
     * FIXME: 可用其他库的 deepEqFn 来对比 options 和 prevOptions
     */
    IntersectionService.prototype.isIntersectionOptionsEqual = function (config, prevConfig) {
        var _a, _b;
        return ((_a = config === null || config === void 0 ? void 0 : config.intersectionOptions) === null || _a === void 0 ? void 0 : _a.rootMargin) === ((_b = prevConfig === null || prevConfig === void 0 ? void 0 : prevConfig.intersectionOptions) === null || _b === void 0 ? void 0 : _b.rootMargin);
    };
    IntersectionService.prototype.monitor = function (getObserveItems) {
        var _this = this;
        this.stopObserve();
        this.stop();
        this.items = getObserveItems();
        this.items.forEach(function (item) {
            var _a;
            (_a = _this.io) === null || _a === void 0 ? void 0 : _a.observe(item);
        });
    };
    IntersectionService.prototype.stopObserve = function () {
        var _this = this;
        this.items.forEach(function (item) {
            var _a;
            (_a = _this.io) === null || _a === void 0 ? void 0 : _a.unobserve(item);
        });
    };
    IntersectionService.prototype.stop = function () {
        var _a;
        (_a = this.io) === null || _a === void 0 ? void 0 : _a.disconnect();
    };
    IntersectionService.prototype.subscribe = function (eventType, observer) {
        this.observableService.subscribe(eventType, observer);
    };
    IntersectionService.prototype.unsubscribe = function (eventType, observer) {
        this.observableService.unsubscribe(eventType, observer);
    };
    IntersectionService.prototype.destroy = function () {
        this.stop();
        this.io = null;
    };
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.IObservableService),
        __metadata("design:type", Object)
    ], IntersectionService.prototype, "observableService", void 0);
    IntersectionService = __decorate([
        (0, inversify_1.injectable)()
    ], IntersectionService);
    return IntersectionService;
}());
exports.IntersectionService = IntersectionService;
